export default __webpack_public_path__ + "static/media/OTPRI.3a2064c6.png";